import { useContext } from 'react';
import { LoadingContext } from '../../data/context/LoadingContext';

/**
 * UseLoader
 * @constructor
 */
export function UseLoader() {
  return useContext(LoadingContext);
}
